import { Helmet } from 'react-helmet-async';
import Herosection from "./herosection/Herosection";
import About from "./about/About";
import Navbar from "./navbar/Navbar";
import Application from "./application/Application";
import Benefits from "./benefits/Benefits";
import Footer from "./footer/Footer";
import Transform from "./transform/Transform";
import Arinnovation from "./arinnovation/Arinnovation";
import Feedback from "./feedback/Feedback";
import Services from "./services/Services";
import Faq from "./faq/Faq";

import "./ARVR.css";

function ARVR() {
  return (
    <div id="arvr">
      <Helmet>
        <title>AR/VR Development Company | Metaverse Solutions | BastionEx</title>
        <meta name="description" content="Professional AR/VR development company building immersive metaverse solutions. Create cutting-edge augmented and virtual reality applications." />
        <link rel="canonical" href="https://bastionex.net/ar-vr-development-services" />
      </Helmet>
      <Navbar />
      <Herosection />
      <About />
      <Transform />
      <Application />
      <Arinnovation />
      <Feedback />
      <Services />
      <Faq />
      {/* <Benefits /> */}
      <Footer />
    </div>
  );
}

export default ARVR;
